import {styled} from '@material-ui/core'
import backgroundSvg from './assets/webtrader-error-message-background.svg'

export const Container = styled('div')({
  alignItems: 'center',
  backgroundImage: `url(${backgroundSvg})`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  height: '100%',
  justifyContent: 'center',
  textAlign: 'center',
  width: '100%',
})

export const PageImage = styled('img')({
  objectFit: 'contain',
})

export const ReturnToDashboardButton = styled('button')({
  background: 'none',
  border: 'none',
  color: '#007AFF',
  cursor: 'pointer',
  fontSize: '16px',
  fontWeight: 500,
  margin: '12px 0 0 0',
  padding: 0,
})

export const Title = styled('h2')({
  color: '#000',
  fontSize: '20px',
  fontWeight: 700,
  textAlign: 'center',
  margin: 0,
})

export const Description = styled('p')({
  color: '#000',
  fontSize: '16px',
  fontWeight: 400,
  textAlign: 'center',
  margin: 0,
})
